import {useMutation} from '@tanstack/react-query';
import {UseFormReturn} from 'react-hook-form';
import {BackendResponse} from '../../http/backend-response/backend-response';
import {onFormQueryError} from '../../errors/on-form-query-error';
import {useNavigate} from '../../ui/navigation/use-navigate';
import {apiClient} from '../../http/query-client';
import {useAuth} from '../use-auth';
import {setBootstrapData} from '@ui/bootstrap-data/bootstrap-data-store';
import {useParams} from 'react-router';
import { requestNotificationPermission } from './firebase-config';
import { BootstrapData } from '@ui/bootstrap-data/bootstrap-data';

interface Response extends BackendResponse {
  // bootstrapData?: string;
  bootstrapData?: BootstrapData;
  message?: string;
  status: 'success' | 'needs_email_verification';
}

export interface RegisterPayload {
  email: string;
  password: string;
  mobile_number : string;
  password_confirmation: string;
  invite_id?: string;
  invite_type?: string;
  deviceId? : string;
  token?: string;
}

export function useRegister(form: UseFormReturn<RegisterPayload>) {
  const navigate = useNavigate();
  const {getRedirectUri} = useAuth();
  const {inviteId} = useParams();

  return useMutation({
    mutationFn: (payload: RegisterPayload) => {
      return register({
        invite_id: inviteId,
        ...payload,
      });
    },
    onSuccess: async (response) => {
      setBootstrapData(response.bootstrapData!);
      if (response.status !== 'needs_email_verification') {

          // await requestNotificationPermission(
          //   () => {},
          //   async (fcmToken) => {
          //      const tokenToUse = fcmToken ?? "your token here";
          //     // if (fcmToken) {
          //       const deviceId = localStorage.getItem('deviceId') || crypto.randomUUID();
          //       localStorage.setItem('deviceId', deviceId);

          //       try {
          //         await apiClient.post('fcm-token', {
          //           token: tokenToUse,
          //           deviceId,
          //         });
          //         // console.log('✅ FCM Token sent to backend');
          //       } catch (err) {
          //         console.error('❌ Error saving FCM token:', err);
          //       }
          //     // }
          //   }
          // );  


        navigate('/');
      } else {
        navigate(getRedirectUri(), {replace: true});
      }
    },
    onError: r => onFormQueryError(r, form),
  });
}

function register(payload: RegisterPayload): Promise<Response> {
  return apiClient
    .post('auth/register', payload)
    .then(response => response.data);
}
